import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, Trash2, Save, Tags } from "lucide-react";

/** Super Admin: kelola Kategori Industri (margin) System HPP. */
export default function HppCategories() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState({});
  const [nw, setNw] = useState({ nama: "", margin_persen: "" });
  const load = () => api.get("/hpp/categories").then((r) => { setItems(r.data); setEdit(Object.fromEntries(r.data.map((c) => [c.id, { nama: c.nama, margin_persen: c.margin_persen }]))); }).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!nw.nama.trim() || nw.margin_persen === "") { toast.error("Isi nama dan margin"); return; }
    try { await api.post("/hpp/categories", { nama: nw.nama, margin_persen: Number(nw.margin_persen) }); setNw({ nama: "", margin_persen: "" }); toast.success("Kategori ditambahkan"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const save = async (id) => {
    try { await api.put(`/hpp/categories/${id}`, { nama: edit[id].nama, margin_persen: Number(edit[id].margin_persen) }); toast.success("Kategori disimpan"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const del = async (c) => {
    if (!window.confirm(`Hapus kategori "${c.nama}"? Simulasi yang sudah memakai kategori ini tetap aman.`)) return;
    try { await api.delete(`/hpp/categories/${c.id}`); toast.success("Kategori dihapus"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="p-4 md:p-8 space-y-4">
      <div>
        <h1 className="text-xl md:text-2xl font-semibold text-slate-900 flex items-center gap-2"><Tags size={22} className="brand-text" /> Kategori Industri</h1>
        <p className="text-xs md:text-sm text-slate-500">Margin standar per kategori (markup dari HPP Total). Berlaku untuk semua user System HPP.</p>
      </div>
      <div className="card-flat p-4 grid grid-cols-1 sm:grid-cols-[1fr_140px_auto] gap-2" data-enter-scope data-testid="hpp-cat-new">
        <Input value={nw.nama} onChange={(e) => setNw({ ...nw, nama: e.target.value })} placeholder="Nama kategori baru" className="h-11 md:h-10" data-testid="hpp-cat-new-nama" />
        <Input type="number" min="0" value={nw.margin_persen} onChange={(e) => setNw({ ...nw, margin_persen: e.target.value })} placeholder="Margin %" className="h-11 md:h-10" data-testid="hpp-cat-new-margin" />
        <Button onClick={add} className="brand-btn rounded-sm h-11 md:h-10" data-enter-submit data-testid="hpp-cat-add"><Plus size={16} className="mr-1" /> Tambah</Button>
      </div>
      <div className="space-y-2">
        {items.map((c) => (
          <div key={c.id} className="card-flat p-3 grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_140px_auto] gap-2 items-center" data-enter-scope data-testid={`hpp-cat-${c.id}`}>
            <Input value={edit[c.id]?.nama ?? ""} onChange={(e) => setEdit({ ...edit, [c.id]: { ...edit[c.id], nama: e.target.value } })} className="h-11 md:h-10 col-span-2 sm:col-span-1" />
            <div className="flex items-center gap-1"><Input type="number" min="0" value={edit[c.id]?.margin_persen ?? ""} onChange={(e) => setEdit({ ...edit, [c.id]: { ...edit[c.id], margin_persen: e.target.value } })} className="h-11 md:h-10" /><span className="text-sm text-slate-500">%</span></div>
            <div className="flex gap-1 justify-end">
              <Button variant="outline" onClick={() => save(c.id)} className="rounded-sm h-11 md:h-10" data-enter-submit data-testid={`hpp-cat-save-${c.id}`}><Save size={15} /></Button>
              <Button variant="outline" onClick={() => del(c)} className="rounded-sm h-11 md:h-10 text-rose-600" data-testid={`hpp-cat-del-${c.id}`}><Trash2 size={15} /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
